import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdateLaboratoryPrescriptionMutation as useChUpdateLaboratoryPrescriptionMutationType } from "@/modules/patients/detail/laboratory-prescription/ch/services/__generated__/useChUpdateLaboratoryPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChUpdateLaboratoryPrescriptionMutation($input: Ch_updateLaboratoryPrescriptionInput!) {
    ch_updateLaboratoryPrescription(input: $input) {
      ch_LaboratoryPrescription {
        id
        ...chLaboratoryPrescriptionDrawerFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdateLaboratoryPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdateLaboratoryPrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdateLaboratoryPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdateLaboratoryPrescriptionMutation }
